export const fetch = (url: any, method: any, param1: any, param2: any) => {
  return new Promise((resolve, reject) => {
    method(url, param1, param2)
      .then((res: any) => resolve(res?.data))
      .catch((err: any) => reject(err?.response?.data));
  });
};
